export const YOUTH = 'YOUTH';
export const MIDDLE = 'MIDDLE';
export const HIGH = 'HIGH';
export const UNIVERSITY = 'UNIVERSITY';
export const CLUB = 'CLUB';
export const PRO = 'PRO';
